<template>
    <div class="container-fluid pt-2">
        <div class="row">
            <div class="col-md-4 col-sm-12">
                <div class="text-left py-3">
                    <h3 class="text-weight-900">Bulk Restock</h3>
                </div>
            </div>
            <div class="col-md-8 col-sm-12">
                <div class="text-left py-3">
                    <button v-b-modal="'restock-list'" class="btn btn-primary py-2 px-3">View Restock List <span class="badge px-1 px-1 badge-light">{{ bulkRestock.itemsToRestock.length  }}</span></button>
                </div>
            </div>
        </div>
        <div>
            <form @submit.prevent="searchItems" class="form-inline py-2">
                <div class="input-group w-100 my-1">
                    <input type="text" ref="search_item_focus" class="form-control" v-model="searchItemToRestock" placeholder="Search Item">
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="submit">
                                <i class="fa fa-search"></i>
                            </button>
                    </div>
                </div>
                <p> <small>Enter the item and select to add to list</small></p>
            </form>
            <!-- <ul class="list-group list-group-flush" style="z-index: 999 !important;">
                    <li @click="searchItemAddToList(item)" v-for="item in itemsSearched" class="list-group-item list-search-item text-primary">
                        {{ item.product }}
                    </li>
                </ul> -->
        </div>
        <div style="margin-bottom: 5em;">
            <table class="table table-sm table-striped">
                <thead>
                    <td>#</td>
                    <td>Item</td>
                    <td>Current Buying Price</td>
                    <td>In stock</td>
                </thead>
                <tbody>
                    <tr v-if="item.is_service !=1" v-for="(item,index) in filterItemsToRestock">
                        <td><input type="checkbox" :value=" item" v-model="bulkRestock.itemsToRestock" /></td>
                        <td>{{ item.product }}</td>
                        <td>{{ item.wholesale_ppu ?? 0 }}</td>
                        <td>{{ item.remaining_units }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <b-modal size="lg" id="restock-list" ref="restockListModal" hide-footer no-close-on-esc no-close-on-backdrop>
            <form @submit.prevent="searchItems" class="form-inline py-2">
                <div class="input-group w-100 my-1">
                    <input type="text" ref="search_item_focus" class="form-control" v-model="searchItemToRestock" placeholder="Search Item">
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="submit">
                                <i class="fa fa-search"></i>
                            </button>
                    </div>
                </div>
                <p> <small>Enter the item and select to add to list</small></p>
            </form>
            <div v-if="showSearchTable">
                <table class="table table-sm table-striped">
                    <thead>
                        <td>#</td>
                        <td>Item</td>
                        <td>Current Buying Price</td>
                        <td>In stock</td>
                    </thead>
                    <tbody>
                        <tr v-if="item.is_service != 1" v-for="(item, index) in filterItemsToRestock.slice(0, 3)" :key="index">
                            <td><input type="checkbox" :value="item" v-model="bulkRestock.itemsToRestock" /></td>
                            <td>{{ item.product }}</td>
                            <td>{{ item.wholesale_ppu ?? 0 }}</td>
                            <td>{{ item.remaining_units }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="text-center">
                <div v-if="supplierDetails.selectedSupplier.supplier">
                    <p class="text-capitalize"><span class="text-bold">Supplier: </span>{{ supplierDetails.selectedSupplier.supplier }}. <a @click="resetSupplier" href="#">Change</a> </p>
                </div>
                <div v-else>
                    <button class="btn btn-block btn-outline-dark" @click="openSupplierSelectionModal">
                                    <span class="h5">
                                        <i class="bi bi-person-circle"></i>
                                    </span>
                                    <span class="text-danger">
                                        Select/Add Supplier
                                    </span>
                                    </button>
                </div>
            </div>
            <div class="text-center py-2">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" v-model="bulkRestock.changeSellingPrice" id="customSwitch1">
                    <label class="custom-control-label" for="customSwitch1">I want to change selling prices</label>
                </div>
            </div>
            <table class="table table-striped table-responsive-sm">
                <thead>
                    <td>Item</td>
                    <td>Qty
                        <p><small class="text-danger">Enter quantities as is on the receipt</small></p>
                    </td>
                    <td>Buying Price
                        <p><small class="text-danger">You can change B.P by editing below</small></p>
                    </td>
                    <td v-if="bulkRestock.changeSellingPrice">Selling Price
                    </td>
                    <td>Total</td>
                </thead>
                <tbody>
                    <tr v-for="(itemSelected,index) in bulkRestock.itemsToRestock">
                        <td>{{ itemSelected.product }}
                        </td>
                        <td><input v-model="itemSelected.restockQty" class="form-control border-right-0 border-left-0 border-top-0 bg-transparent" type="text" required/></td>
                        <td><input v-model="itemSelected.wholesale_ppu" class="form-control border-right-0 border-left-0 border-top-0 bg-transparent" /></td>
                        <td v-if="bulkRestock.changeSellingPrice"><input v-model=" itemSelected.ppu" class="form-control border-right-0 border-left-0 border-top-0 bg-transparent" /></td>
                        <td>{{ itemSelected.totalBuying}} </td>
                        <td><a @click="removeFromArray(index)" class="text-danger h5"><i class="bi bi-x-circle"></i></a></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td v-if="bulkRestock.changeSellingPrice"></td>
                        <td>
                            <h5>Total:</h5>
                        </td>
                        <td>
                            <h5>{{ totalBuyingSum }}</h5>
                        </td>
                    </tr>
                </tbody>
            </table>
            <small>You can add an item that is not in your inventory as well</small>
            <p><a v-b-modal="'new-item-modal'" class="text-c">Create an Item</a></p>
            <hr />
            <div class="container">
                <input class="form-check-input" type="checkbox" v-model="bulkRestock.changeBuyingPriceImmediately" id="defaultCheck1">
                <label class="form-check-label" for="defaultCheck1">
                       I want to apply this new buying price immediately
                    </label>
                <p>
                    <small class="text-danger">Leaving this will update buying price after old stock is sold out</small>
                </p>
                <hr />
                <div class="form-group">
                    <label>Supplier Invoice No./Delivery Note</label>
                    <input class="form-control" placeholder="e.g INV-01"  v-model="bulkRestock.receipt_number" type="text" />
                </div>
                <div class="form-group">
                    <label>Invoice Date</label>
                    <input class="form-control"  v-model="bulkRestock.due_date" type="date" />
                </div>
                <div class="form-group">
                    <label>Amount paid</label>
                    <p><small>This is to track debt</small></p>
                    <input class="form-control"  v-model="bulkRestock.amount_paid" type="text" />
                </div>

                <p>Add files/image of Receipt or Goods Received Note</p>
                <input class="d-none" v-model="bulkRestock.receiptFile" type="hidden" />
                <vue-dropzone ref="myVueDropzone" id="customdropzone" :options="dropzoneOptionsProductImages" :useCustomSlot="true" v-on:vdropzone-success="uploadImageSuccess" v-on:vdropzone-error="uploadError" v-on:vdropzone-removed-file="fileRemoved">
                    <div class="dropzone-custom-content">
                        <div class="text-center">
                            <p class="text-secondary"> <i class="fas fa-file-alt"></i></p>
                            <p><small class="dropzone-custom-title text-secondary py-2">Drag & Drop</small></p>
                            <a class="btn btn-outline-secondary" href="#">Choose File</a>
                            <p><small class="text-secondary">Max file size 10MB</small></p>
                        </div>
                    </div>
                </vue-dropzone>
                <!-- <button @click="openCamera">Open Camera</button> -->
                <input type="file" ref="cameraInput" accept="image/*" capture="camera" style="display: none;" @change="onCameraChange">
                <div class="text-center">
                    <div class="py-2">
                        <button class="btn btn-primary" v-b-modal="'verify-restock-b4-submit'">Submit New Stock</button>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal id="verify-restock-b4-submit" hide-footer>
            <div class="text-center">
                <div class="py-4">
                    <p>Are you sure you want to restock these items?</p>
                    <a @click="completeRestock" class="btn btn-primary" :class="{ 'disabled': !confirmIsNotComplete }" :disabled="!confirmIsNotComplete">
                            Yes! Restock
                            </a>
                </div>
            </div>
        </b-modal>
        <b-modal ref="supplierSelectionModal" hide-footer>
            <p>Supplier details</p>
            <small>To add or search supplier just type the name of supplier</small>
            <div v-if="supplierDetails.selectedSupplier.supplier">
                <p class="text-capitalize"><span class="text-bold">Supplier: </span>{{ supplierDetails.selectedSupplier.supplier }}. <a @click="resetSupplier" href="#">Change</a> </p>
            </div>
            <div class="form-group">
                <input class="form-control" v-model="supplierDetails.searchTerm" placeholder="Supplier name">
                <div v-if="supplierDetails.searchTable == true">
                    <div v-if="supplierDetails.filteredSuppliers.length > 0">
                        <table class="table table-striped table-sm">
                            <thead>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Email</th>
                            </thead>
                            <tbody>
                                <tr class="text-dark text-capitalize underline text-sm" v-for="supplier in supplierDetails.filteredSuppliers" :key="supplier.id" @click="rowSelectSupplier(supplier)">
                                    <td class="text-primary underline-primary">{{ (supplier.supplier) ? supplier.supplier : '' }}</td>
                                    <td>{{ (supplier.phone) ? supplier.phone :'' }}</td>
                                    <td>{{ (supplier.email) ? supplier.email :'' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else>
                        <a @click="openAddSupplierModal" href="#">Create supplier - {{ supplierDetails.searchTerm }}</a>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal id="new-item-modal" hide-footer>
            <form v-if="itemsForm.is_Service === false" class="mb-5 form-signin-product" @submit.prevent="submitProduct">
                <!-- <div class="container">
                                            <div class="row align-items-center h-100">
                                                <div class="col-12 mx-auto">
                                                    <div class="jumbotron">
                                                        <fileuploader></fileuploader>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->
                <div class="text-center">
                    <h5 class="text-dark text-left text-weight-400 pb-2">Product Details</h5>
                </div>
                <div class="form-group">
                    <label>Item Name</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Item Title" v-model="itemsForm.title" required/>
                </div>
                <div class="form-group">
                    <label>Buying Price</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Price per unit" v-model="itemsForm.wholesale_ppu" required/>
                    <small class="pl-3 text-dark">Wholesale Price per unit</small>
                </div>
                <div class="form-group">
                    <label>Selling Price</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Price per unit" v-model="itemsForm.ppu" required/>
                    <small class="pl-3 text-dark">Retail Price per unit</small>
                </div>
                <div class="form-group">
                    <label>Measuring Unit</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Measuring Unit" v-model="itemsForm.measuring_unit	" required/>
                    <small class="pl-3 text-dark">Measuring Unit (Kgs,Pieces,Litres etc)</small>
                </div>
                <div class="form-group">
                    <label>SKU - store keeping unit</label>
                    <input type="text" class="form-control border" placeholder="sku" v-model="itemsForm.sku" />
                    <small class="pl-3 text-dark">Store keeping unit</small>
                </div>
                <div class="form-group">
                    <label>Item Count (Quantities)</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Quantity" v-model="itemsForm.qty" required/>
                    <small class="pl-3 text-dark">eg. 10</small>
                </div>
                <div class="form-group">
                    <label>Item Category</label><span class="text-danger">*</span>
                    <p class="text-danger" v-if="itemsForm.categorySelectError !==''">{{ itemsForm.categorySelectError }}</p>
                    <p class="text-danger" v-if="categoryOptions.length === 1">Seems you don't have any category - <a href="#" @click="createProductCatModal">Create One</a></p>
                    <b-form-select v-model="itemsForm.selectedCategory" :options="categoryOptions">
                    </b-form-select>
                    <!-- <p class="text-dark" v-if="categoryOptions.length > 1">Can't see a category - <a href="#" @click="createProductCatModal">Add One</a></p> -->
                </div>
                <button class="btn btn-block btn-primary" type="submit">Create Item</button>
            </form>
        </b-modal>
        <b-modal ref="newSupplierModal" id="new-supplier-modal" hide-footer static>
            <div class="container text-center">
                <div class="text-centre">
                    <h2 class="font-weight-bold ">Add New Supplier</h2>
                </div>
            </div>
            <div class="container py-3">
                <!-- Actual search box -->
                <form @submit.prevent="createNewSupplier">
                    <p>Company details</p>
                    <div class="form-group">
                        <input class="form-control border-bottom" v-model="supplierDetails.supplier.supplier" type="text" placeholder="Company Name" required/>
                    </div>
                    <div class="form-row py-1">
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="supplierDetails.supplier.email" type="email" placeholder="Email" />
                        </div>
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="supplierDetails.supplier.phone" type="text" placeholder="Phone Number" />
                        </div>
                    </div>
                    <hr />
                    <p>Company representative details</p>
                    <div class="form-row py-1">
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="supplierDetails.supplier.supplier_representatives.name" type="text" placeholder="Representative " />
                        </div>
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="supplierDetails.supplier.supplier_representatives.phone" type="text" placeholder="Phone" />
                        </div>
                    </div>
                    <div class="form-group pt-3">
                        <button class="btn btn-primary btn-block">Add Supplier</button>
                    </div>
                </form>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
import productCacheService from '../IndexDB/productCacheService';
    export default {
        components: {
            vueDropzone: vue2Dropzone
        },
        data() {
            return {
                itemList: {},
                confirmIsNotComplete: true,
                showSearchTable: false,
                bulkRestock: {
                    itemsToRestock: [],
                    changeSellingPrice: false,
                    totalAmount: 0,
                    changeBuyingPriceImmediately: false,
                    receiptFile: [],
                    amount_paid: 0,
                    receipt_number: '',
                    due_date: '',
                },
                itemsForm: {
                    selectedCategory: null,
                    title: '',
                    qty: '',
                    measuring_unit	: '',
                    wholesale_ppu: '',
                    wholesale_sp: '',
                    ppu: '',
                    categorySelectError: '',
                    is_Service: false,
                    sku: '',
                },
                categoryOptions: [{
                    value: null,
                    text: 'Select Category'
                }],
                dropzoneOptionsProductImages: {
                    url: "/api/files",
                    addRemoveLinks: true,
                    maxFiles: 5,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                },
                searchItemToRestock: '',
                itemsSearched: {},
                supplierDetails: {
                    supplier: {
                        email: '',
                        phone: '',
                        supplier: '',
                        supplier_representatives: {
                            name: '',
                            email: '',
                            phone: ''
                        },
                    },
                    searchTerm: '',
                    searchTable: false,
                    filteredSuppliers: {},
                    selectedSupplier: {}
                }
            }
        },
        mounted() {
            this.getAllProducts()
            this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
                if (modalId === 'new-item-modal') {
                    this.getCategories()
                }
            })
        },
        created() {
            this.setDefaultRestockQty();
              this.bulkRestock.amount_paid = this.totalBuyingSum

        },
        computed: {
            updatedItemsToRestock() {
                // Compute the totalBuying for each itemSelected
                this.bulkRestock.itemsToRestock.forEach(item => {
                    // Check for NaN or undefined values and set to default if needed
                    const restockQty = isNaN(item.restockQty) || item.restockQty === undefined ? 0 : item.restockQty;
                    const wholesale_ppu = isNaN(item.wholesale_ppu) || item.wholesale_ppu === undefined ? 0 : item.wholesale_ppu;
                    this.$set(item, 'totalBuying', restockQty * wholesale_ppu);
                });
                return this.bulkRestock.itemsToRestock;
            },
          filterItemsToRestock() {
            return Object.values(this.itemList).filter(item => {
                const search = this.searchItemToRestock.toLowerCase();

                const sku = item?.sku?.toLowerCase?.() || '';
                const product = item?.product?.toLowerCase?.() || '';

                const isSkuMatch = sku === search;
                const isProductMatch = product.includes(search);

                if (isSkuMatch) {
                    this.bulkRestock.itemsToRestock.push(item); // ✅ Call function here
                }

                return isSkuMatch || isProductMatch;
            });
        },
            totalBuyingSum() {
                return this.bulkRestock.itemsToRestock.reduce((total, item) => {
                    // Check for NaN or undefined values and set to default if needed
                    const restockQty = isNaN(item.restockQty) || item.restockQty === undefined ? 1 : item.restockQty;
                    const wholesale_ppu = isNaN(item.wholesale_ppu) || item.wholesale_ppu === undefined ? 0 : item.wholesale_ppu;
                    const totalBuying = restockQty * wholesale_ppu;
                    // Add totalBuying to the accumulator
                    return parseFloat((total + totalBuying).toFixed(2));
                }, 0);
            }
        },
        watch: {
            'bulkRestock.itemsToRestock': {
                handler(newVal, oldVal) {
                    // Recalculate totals when itemsToRestock changes
                    newVal.forEach(item => {
                        // Check for NaN or undefined values and set to default if needed
                        const restockQty = isNaN(item.restockQty) || item.restockQty === undefined ? 1 : item.restockQty;
                        const wholesale_ppu = isNaN(item.wholesale_ppu) || item.wholesale_ppu === undefined ? 0 : item.wholesale_ppu;
                        this.$set(item, 'totalBuying', parseFloat((restockQty * wholesale_ppu).toFixed(2)));
                        this.showSearchTable = false;
                    })
                },
                deep: true
            },
            'supplierDetails.searchTerm': function() {
                if (this.supplierDetails.searchTerm.length > 0) {
                    this.supplierDetails.searchTable = true
                    this.searchSupplier();
                } else {
                    this.supplierDetails.searchTable = false
                }
            },
            totalBuyingSum(newVal, oldVal) {
                    this.bulkRestock.amount_paid = newVal;
                },
            searchItemToRestock(before, after) {
                this.showSearchTable = true;
            }
        },
        methods: {
            submitProduct() {
                if (this.itemsForm.selectedCategory !== null) {
                    axios.post('/api/addprod', { ...this.itemsForm
                    }).then(results => {
                        if (results.status === 200) {
                            const product = {
                                ...results.data.product, // Spread existing product data
                                restockQty: results.data.product.remaining_units, // Add restockQty explicitly
                                dontAdd: 1 // Add restockQty explicitly
                            };
                            this.bulkRestock.itemsToRestock.push(product);
                            this.$bvModal.hide('new-item-modal');
                        }
                    }).catch()
                } else {
                    this.itemsForm.categorySelectError = 'You need to select a category'
                }
            },
            createProductCatModal() {
            },
            getCategories() {
                axios.get('/api/items-category').then(results => {
                    $.each(results.data, (key, value) => {
                        const itemCat = {
                            value: value.id,
                            text: value.name
                        }
                        this.categoryOptions.push(itemCat)
                    })
                }).catch(errors => {
                    console.log(errors)
                })
            },
            removeFromArray(index) {
                if (index > -1) {
                    this.bulkRestock.itemsToRestock.splice(index, 1);
                }
            },
            async getAllProducts() {
                await axios.get('/api/only-products').then(results => {
                    this.itemList = results.data
                }).catch(error => {})
            },
            openCamera() {
                const videoElement = document.createElement('video');
                const canvasElement = document.createElement('canvas');
                const constraints = {
                    video: true,
                };
                navigator.mediaDevices.getUserMedia(constraints)
                    .then((stream) => {
                        videoElement.srcObject = stream;
                        videoElement.play();
                        const captureButton = document.createElement('button');
                        captureButton.innerText = 'Capture';
                        document.body.appendChild(videoElement);
                        document.body.appendChild(captureButton);
                        captureButton.addEventListener('click', () => {
                            canvasElement.width = videoElement.videoWidth;
                            canvasElement.height = videoElement.videoHeight;
                            canvasElement.getContext('2d').drawImage(videoElement, 0, 0);
                            this.image = canvasElement.toDataURL('image/png');
                            this.file = this.dataURLtoFile(this.image, 'captured.png');
                            this.$refs.myVueDropzone.manuallyAddFile(this.file); // Add the captured image to VueDropzone
                            stream.getTracks().forEach(track => track.stop());
                            document.body.removeChild(videoElement);
                            document.body.removeChild(captureButton);
                        });
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            onCameraChange(event) {
                const file = event.target.files[0];
                if (file) {
                    this.$refs.myVueDropzone.manuallyAddFile(file); // Add the selected file to VueDropzone
                }
            },
            uploadSuccess(file, response) {
                this.$toasts.push({
                    type: 'success',
                    message: "File uploaded successfully",
                });
            },
            uploadImageSuccess(file, response) {
                this.$toasts.push({
                    type: 'success',
                    message: "File uploaded successfully",
                });
                this.bulkRestock.receiptFile.push(response.file)
            },
            uploadError(file, message) {
                this.$toasts.push({
                    type: 'error',
                    message: "There was an error uploading your file",
                });
            },
            fileRemoved(file) {
                if (file.serverResponse) {
                    this.bulkRestock.receiptFile = this.bulkRestock.receiptFile.filter(f => f !== file.serverResponse);
                } else {
                    // If no serverResponse, match using file name or other attributes
                    const fileResponse = JSON.parse(file.xhr.response);
                    const fileName = fileResponse.file;
                    // Find the index of the file name in receiptFile array
                    const index = this.bulkRestock.receiptFile.findIndex(f => f === fileName);
                    if (index > -1) {
                        // Remove the file from the array
                        this.bulkRestock.receiptFile.splice(index, 1);
                    }
                }
            },
            setDefaultRestockQty() {
                this.bulkRestock.itemsToRestock.forEach(item => {
                    if (item.restockQty === undefined || item.restockQty === null) {
                        this.$set(item, 'restockQty', 1);
                    }
                });
            },
            async openSupplierSelectionModal() {
                await this.getSuppliers()
                this.$refs.supplierSelectionModal.show()
            },
            async createNewSupplier() {
                await axios.post('/api/new-supplier', { ...this.supplierDetails.supplier
                }).then(results => {
                    if (results.status === 200) {
                        this.supplierDetails.supplier = results.data.supplier
                        this.supplierDetails.supplier.supplier_representatives = results.data.rep.supplier_representatives
                        this.supplierDetails.selectedSupplier = results.data.supplier
                        this.bulkRestock.supplier = results.data.supplier.id
                        this.$refs.newSupplierModal.hide()
                    }
                }).catch(errors => {})
            },
            rowSelectSupplier(supplier) {
                this.supplierDetails.selectedSupplier = supplier
                this.bulkRestock.supplier = supplier.id
                this.$refs.supplierSelectionModal.hide()
            },
            resetSupplier() {
                this.supplierDetails.selectedSupplier = {}
                this.supplierDetails.searchTerm = ''
                this.$refs.supplierSelectionModal.show
            },
            searchSupplier() {
                const searchTerm = this.supplierDetails.searchTerm.toLowerCase();
                this.supplierDetails.filteredSuppliers = this.supplierDetails.supplier.filter(supplier =>
                    (supplier.supplier && supplier.supplier.toLowerCase().includes(searchTerm)) ||
                    (supplier.email && supplier.email.toLowerCase().includes(searchTerm)) ||
                    (supplier.phone && supplier.phone.includes(searchTerm))
                );
            },
            openAddSupplierModal() {
                this.supplierDetails.supplier.supplier = this.supplierDetails.searchTerm
                this.$refs.newSupplierModal.show()
            },
            async completeRestock() {
                this.confirmIsNotComplete = false
                this.bulkRestock.totalAmount = this.totalBuyingSum;
                await axios.post('/api/purchases', { ...this.bulkRestock
                }).then(results => {
                    if (results.status === 200) {
                        productCacheService.hotReloadLocalDB()
                        window.location.replace('/inventory')
                    }
                }).catch(error => {
                    this.$toasts.push({
                        'type': 'error',
                        'message': "There was an error"
                    })
                    this.confirmIsNotComplete = true
                })
            },
            searchItemAddToList(item) {
                if (!this.bulkRestock.itemsToRestock.includes(item)) {
                    this.bulkRestock.itemsToRestock.push(item)
                    this.itemsSearched = {}
                } else {
                    const index = this.bulkRestock.itemsToRestock.indexOf(item);
                    if (index !== -1) {
                        this.bulkRestock.itemsToRestock.splice(index, 1);
                        this.itemsSearched = {}
                    }
                }
            },
            async getSuppliers() {
                await axios.get('/api/all-suppliers')
                    .then(result => {
                        this.supplierDetails.supplier = result.data;
                        this.supplierDetails.supplier.supplier_representatives = {};
                    });
            },
        },
    }
</script>

<style>
    .list-search-item {
        margin: 0.5em 0 0.5em 0;
        padding: 0;
    }
    small {
        font-size: 11px !important;
    }
    #customdropzone {
        min-width: 320px;
        min-height: 180px;
    }
</style>
